// Packages
import { useState, useEffect } from "react";
// import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import toast from "react-hot-toast";
import moment from "jalali-moment";
// Components
import UserPanelCard from "../../Common/Card/UserPanelCard/UserPanelCard";
import LineChartComponent from "../../Common/charts/LineChart/LineChart";
import BarChartComponent from "../../Common/charts/BarChart/BarChart";
import RadialChartComponent from "../../Common/charts/RadialChart/RadialChart";
// API
import {
  deleteSavedItem,
  getHalfReadBooks,
  getInterests,
  getReadingTime,
  getSavedItems,
} from "../../../Services/usersService";
// import convertNumbersToPersian from "../../../Utils/convertNumbersToPersian";

const Reports = ({ Styles, decodedToken, token, handleEditProfile }) => {
  // const [textualSubscriptionStatus, setTextualSubscriptionStatus] = useState();
  // const [imageSubscriptionStatus, setImageSubscriptionStatus] = useState();
  const [savedItems, setSavedItems] = useState([]);
  const [savedItemsChanged, setSavedItemsChanged] = useState(false);
  const [quarterly, setQuarterly] = useState([]);
  const [bookContinue, setbookContinue] = useState([]);

  const [readingTime, setReadingTime] = useState([]);
  const [filteredReadingTime, setFilteredReadingTime] = useState([]);
  // {
  //   day: "یکشنبه",
  //   time: 2,
  // }
  const [barChartdata, setBarChartData] = useState([]);
  // {
  //   subject: "علمی",
  //   percentage: 10,
  // },
  const [radialChartdata, setRadialChartData] = useState([]);
  // {
  //   subject: "علمی",
  //   percentage: 12,
  //   fill: "#4B495B",
  // },

  useEffect(() => {
    const api = async () => {
      try {
        const { data } = await getHalfReadBooks();
        setbookContinue(data.halfReadBooks);
      } catch (ex) {
        console.log(ex);
        toast.error(ex.response.data.message);
      }
    };
    api();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        // line chart
        const { data } = await getReadingTime();
        setReadingTime(data.readingTime);
      } catch (ex) {
        console.log(ex);
        toast.error(ex.response.data.message);
      }
    };
    if (token) {
      fetchData();
    }
  }, [token]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const { data: interests } = await getInterests();
        const radialChart = [];
        interests.interests.forEach(({ subject, percentage }) => {
          radialChart.push({ subject, percentage, fill: "#4B495B" });
        });
        setRadialChartData(radialChart);
        setBarChartData(interests.interests);
      } catch (ex) {
        console.log(ex);
        toast.error(ex.response.data.message);
      }
    };
    if (token) {
      fetchData();
    }
  }, [token]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const { data: userSavedItems } = await getSavedItems();
        setSavedItems(userSavedItems.savedItems);
      } catch (ex) {
        console.log(ex);
        toast.error(ex.response.data.message);
      }
    };
    if (token) {
      fetchData();
    }
  }, [token, savedItemsChanged]);

  const [reports, setReports] = useState();

  useEffect(() => {
    const currentDate = moment();
    const weekAgoDate = moment().subtract(7, "days");

    const filteredData = readingTime.filter((item) => {
      const itemDate = moment(item.day, "jYYYY-jMM-jDD");
      return itemDate >= weekAgoDate && itemDate <= currentDate;
    });

    setFilteredReadingTime(filteredData);

    const totalStudyTime = filteredData.reduce(
      (total, item) => total + item.time,
      0
    );
    setReports((totalStudyTime / 3600).toFixed(2));
  }, [readingTime]);

  // useEffect(() => {
  //   if (decodedToken && decodedToken.user.subscriptionStatus.length > 0) {
  //     const textualSubscription = decodedToken.user.subscriptionStatus.filter(
  //       (i) => i.imageOrTextual === "textual"
  //     );
  //     const imageSubscription = decodedToken.user.subscriptionStatus.filter(
  //       (i) => i.imageOrTextual === "image"
  //     );
  //     const start = new Date();
  //     if (textualSubscription.length > 0) {
  //       const textualEnd = new Date(textualSubscription[0].endDate);
  //       const textualTimeDifference = textualEnd - start;
  //       const textualDaysDifference =
  //         textualTimeDifference / (1000 * 60 * 60 * 24);
  //       setTextualSubscriptionStatus(textualDaysDifference);
  //     }
  //     if (imageSubscription.length > 0) {
  //       const imageEnd = new Date(imageSubscription[0].endDate);
  //       const imageTimeDifference = imageEnd - start;
  //       const imageDaysDifference = imageTimeDifference / (1000 * 60 * 60 * 24);
  //       setImageSubscriptionStatus(imageDaysDifference);
  //     }
  //   }
  // }, [decodedToken]);

  const handleChangeReport = (event) => {
    const currentDate = moment();
    const weekAgoDate = moment().subtract(event.target.value, "days");

    const filteredData = readingTime.filter((item) => {
      const itemDate = moment(item.day, "jYYYY-jMM-jDD");
      return itemDate >= weekAgoDate && itemDate <= currentDate;
    });

    setFilteredReadingTime(filteredData);

    const totalStudyTime = filteredData.reduce(
      (total, item) => total + item.time,
      0
    );

    setReports((totalStudyTime / 3600).toFixed(2));
  };

  const handleDeleteSavedItem = (id, kind) => {
    toast.promise(deleteSavedItem({ id, kind }), {
      loading: "در حال حذف مقاله از ذخیره ها . . .",
      success: (res) => {
        setSavedItemsChanged((prev) => !prev);
        return res.data.message;
      },
      error: (res) => res.response.data.message,
    });
  };

  // function convertSecondsToHours(seconds) {
  //   const hours = seconds / 3600;
  //   const formattedHours = hours.toFixed(2);

  //   return formattedHours;
  // }

  const calculateRadialChartData = (chartData) => {
    const totalPercentage = chartData.reduce(
      (acc, item) => acc + item.percentage,
      0
    );

    // ایجاد درصدهای جدید بر اساس مجموع
    const newData = chartData.map((item) => ({
      subject: item.subject,
      percentage: ((item.percentage / totalPercentage) * 100).toFixed(2),
    }));
    return newData;
  };
  return (
    <div className={Styles.allDataContainer}>
      <div className={Styles.reportsContainer}>
        <motion.div
          initial={{ x: -1000 }}
          animate={{ x: 0 }}
          transition={{ duration: 0.8, delay: 0.3 }}
          className={Styles.userDetailsContainer}
        >
          <div onClick={handleEditProfile} className={Styles.imageContainer}>
            <h2>{decodedToken?.user.fullname[0].toUpperCase()}</h2>
          </div>
          <div className={Styles.detailsContainer}>
            <div className={`${Styles.details} ${Styles.name}`}>
              <h3>نام کاربری :</h3>
              <h3>{decodedToken?.user.fullname}</h3>
            </div>
            {/* <div className={`${Styles.details} ${Styles.subs}`}>
              {decodedToken?.user.subscriptionStatus.length > 0 ? (
                decodedToken?.user.subscriptionStatus.map((sub, index) => (
                  <div className={Styles.subsContainer} key={index}>
                    <h3>
                      اشتراک{" "}
                      {sub.imageOrTextual === "textual"
                        ? "مقالات متنی"
                        : "مقالات تصویری"}{" "}
                      :
                    </h3>
                    <h3 key={index}>
                      {convertNumbersToPersian(
                        sub.imageOrTextual === "textual"
                          ? textualSubscriptionStatus?.toFixed(0).toString()
                          : imageSubscriptionStatus?.toFixed(0).toString()
                      )}{" "}
                      روز
                    </h3>
                  </div>
                ))
              ) : (
                <div
                  className={`${Styles.subsContainer} ${Styles.havNotSubscription}`}
                >
                  <h3>اشتراک ندارید :</h3>
                  <Link
                    to="/users/panel/cart"
                    className={Styles.subscriptionButton}
                  >
                    تهیه اشتراک
                  </Link>
                </div>
              )}
            </div> */}
          </div>
        </motion.div>
        <motion.div
          initial={{ x: -1000 }}
          animate={{ x: 0 }}
          transition={{ duration: 0.8, delay: 0.5 }}
          className={Styles.userReportsContainer}
        >
          <h2 className={Styles.title}>گزارش مطالعاتی شما</h2>
          <div className={Styles.reports}>
            <div className={Styles.lineChartContainer}>
              <div
                className={Styles.chart}
                style={
                  readingTime.length === 0
                    ? {
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }
                    : {}
                }
              >
                {readingTime.length === 0 ? (
                  <div>داده ای برای نمایش وجود ندارد</div>
                ) : (
                  <LineChartComponent data={filteredReadingTime} />
                )}
              </div>
              <div className={Styles.details}>
                <div className={Styles.container}>
                  <h4>گزارش :</h4>
                  <select
                    onChange={(time) => handleChangeReport(time)}
                    name="period"
                    id="periodOptions"
                  >
                    <option value={7}>هفتگی</option>
                    <option value={30}>ماهانه</option>
                    <option value={90}>3 ماهه</option>
                    <option value={180}>6 ماهه</option>
                    <option value={365}>1 ساله</option>
                  </select>
                </div>
                <div className={Styles.learingContainer}>
                  <h4>میانگین ساعت مطالعاتی</h4>
                  <div className={Styles.learningHours}>
                    <h4>{reports} ساعت</h4>
                  </div>
                </div>
                <div className={Styles.learingContainer}>
                  <h4>میزان مطالعه امروز</h4>
                  <div className={Styles.learningHours}>
                    <h4>
                      {readingTime.length === 0
                        ? 0
                        : (
                            readingTime[readingTime.length - 1].time / 3600
                          ).toFixed(2)}{" "}
                      ساعت
                    </h4>
                  </div>
                </div>
              </div>
            </div>
            <div className={Styles.otherChartsContainer}>
              <div className={Styles.barChartContainer}>
                <h4>میزان علاقه شما</h4>
                <div
                  className={Styles.chartContainer}
                  style={
                    barChartdata.length === 0
                      ? {
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }
                      : {}
                  }
                >
                  {barChartdata.length === 0 ? (
                    <div>داده ای برای نمایش وجود ندارد</div>
                  ) : (
                    <BarChartComponent data={barChartdata} />
                  )}
                </div>
              </div>
              <div className={Styles.radialChartContainer}>
                <h4>مطالب مورد علاقه شما</h4>
                <div
                  className={Styles.chartContainer}
                  style={
                    radialChartdata.length === 0
                      ? {
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }
                      : {}
                  }
                >
                  {radialChartdata.length === 0 ? (
                    <div>داده ای برای نمایش وجود ندارد</div>
                  ) : (
                    <RadialChartComponent
                      data={calculateRadialChartData(radialChartdata)}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
      {/* center */}
      <motion.div
        initial={{ x: -1200 }}
        animate={{ x: 0 }}
        transition={{ duration: 1 }}
        className={Styles.centerContainer}
      >
        <UserPanelCard
          kind="کتاب"
          title1="ادامه"
          title2="مطلب"
          subjects={bookContinue}
        />
        <UserPanelCard
          title1="نشان"
          title2="شده"
          title3="ها"
          subjects={savedItems}
          handleDeleteSavedItem={handleDeleteSavedItem}
        />
        <UserPanelCard title1="فصلنامه" title2="ها" subjects={quarterly} />
      </motion.div>
    </div>
  );
};

export default Reports;
